import { defineStore } from 'pinia'
import { ref } from 'vue'
import type { Cuttle } from '@shared/types'
import { apiService } from '@/services/api'

export const useGameStore = defineStore('game', () => {
  // State
  const isLoading = ref(false)
  const cuttles = ref<Cuttle[]>([])
  const selectedCuttle = ref<Cuttle | null>(null)

  // Actions
  async function initialize() {
    isLoading.value = true
    try {
      // Initialize game data
      await loadUserData()
    } catch (error) {
      console.error('Game initialization failed:', error)
    } finally {
      isLoading.value = false
    }
  }

  async function loadUserData(userAddress?: string) {
    try {
      // Load user's Cuttles from API
      cuttles.value = await apiService.getCuttles(userAddress)
    } catch (error) {
      console.error('Failed to load user data:', error)
    }
  }

  function reset() {
    cuttles.value = []
    selectedCuttle.value = null
    isLoading.value = false
  }

  function selectCuttle(cuttle: Cuttle) {
    selectedCuttle.value = cuttle
  }

  return {
    // State
    isLoading,
    cuttles,
    selectedCuttle,
    
    // Actions
    initialize,
    loadUserData,
    reset,
    selectCuttle
  }
})